import React from 'react';
import history from '../../assests/img/history.jpg';

const History = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>History</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    History
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <p>
                                                    <img style={{ paddingLeft: "15px", float: "right" }} src={history} alt="history" width="293" height="305" />
                                                    A humble, affable, humane, principled and assiduous farmer, Ch. Karamchand,
                                                    who was born in the placid and tranquil village of Bass, Haryana
                                                    (erstwhile Punjab), in the tumultuous years of 1920’s when the world
                                                    had just witnessed the horrors of world war-I and Indian society was
                                                    being oppressed by its colonial masters. Since his early childhood days
                                                    he had nurtured a dream of getting good education and contributing towards
                                                    the overall upliftment of rural society in Haryana. But destiny had other
                                                    plans as he was Orphaned at a young age and thus had to fend for himself
                                                    instead of engaging in intellectual toils. Having witnessed the horrors of
                                                    partition, he realised the fickle and capricious nature of material
                                                    possessions and this strengthened his faith and belief in education
                                                    and <br />learning.
                                                </p>
                                                <p>It was in 1956, nearly a decade after independence,
                                                    that he vowed to set aside a portion of his land for
                                                    construction of school in his village so that village
                                                    children, irrespective of their socio-economic status
                                                    could have an access to quality education. He worked
                                                    hard his entire life towards achieving his goal and
                                                    finally his vision and lifelong dream was fulfilled
                                                    by his son Sh. Ramphal Mor, who after dedicating 40+
                                                    years of his life towards teaching and education, laid
                                                    the foundation stone of Karamchand Memorial School on
                                                    the same piece of land set aside by his father. Karamchand
                                                    Memorial School is the living embodiment of six core values
                                                    that late Ch. Karamchand lived by. These are: Kindness &amp;
                                                    Mutual Respect, Curiosity, Integrity, Perseverance, Truth
                                                    and Humility. They form the robust skeleton of Karamchand
                                                    Memorial school and will guide us in our future endeavours.
                                                    Thus begins the journey of KCMS
                                                </p>
                                            </div>
                                        </div>

                                        <div
                                            className="col-xl-3 col-lg-6 wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="bg-lgrey">
                                                <div className="subMenubg active">
                                                    <a href="about-us" target="_self" className="submenu">
                                                        About Us
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="our-inspiration"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Our Inspiration
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="history" target="_self" className="submenu">
                                                        History
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a className="submenu">
                                                        Messages
                                                    </a>
                                                    <div className="founder_link">
                                                        <div className="subMenubg">
                                                            <a href="founder-message" className="submenu">
                                                                Founder’s Message
                                                            </a>
                                                        </div>
                                                        <div className="subMenubg">
                                                            <a href="director-message" className="submenu">
                                                                Director’s Message
                                                            </a>
                                                        </div>
                                                        <div className="subMenubg">
                                                            <a href="patron-message" className="submenu">
                                                                Patron Message
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="our-aims" target="_self" className="submenu">
                                                        Our Aims
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="our-ethos"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Our Ethos
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="our-vision.html"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Our Vision
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        {/* <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button> */}
                    </div>
                </div>
            </div >
        </>
    )
}

export default History;